<script setup lang="ts">
import { useRoute } from 'vue-router'
import PageExternalEditor from '@/views/PageExternalEditor.vue'
import PageExternalEditorBeta from '@/views/PageExternalEditorBeta.vue'
import { hasBetaPanelQuery } from '@/utils/panel-variant'

const route = useRoute()
</script>

<template>
    <PageExternalEditorBeta v-if="hasBetaPanelQuery(route.query)" :key="String(route.params.id)" />
    <PageExternalEditor v-else />
</template>
